import * as $ from 'jquery';
import 'bootstrap';
import 'MagnificPopup';
import * as Cookies from 'js-cookie';
import {headerContent} from './c002';
import {bookingFormCommon} from './c005-bookingform-common';

export class enrichMenuLogout {
	 
    logoutHandler(): void {
		let _self = this;

    $(".enrichMenulogoutLink").on("click",function() {
    	// clearUserDataOnLogout();
    	// var redirectTo = $(this).attr("data-redirectto");
    	// if(redirectTo && redirectTo != "") {
    	// 	window.location.href = redirectTo;
    	// } else {
    	// 	location.reload();
		// }
		//alert("in js.... logoutHandler method");
	  	_self.logOutUser();
    });
    }
    logOutUser():void {
		let _self = this;
		let redirectTo:string = $(".enrichMenulogoutLink").attr("data-redirectto");
		//alert("redirectTo>>"+redirectTo);
		_self.clearUserDataOnLogout();

		if (redirectTo && redirectTo != "") {
			window.location.href = redirectTo;
		} else {
			location.reload();
		}
    }
    clearUserDataOnLogout():void {
	//	document.cookie = "jade=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "phantom=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "userName=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "milesCount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "flyerID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "memberStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		document.cookie = "isSummaryLoaded=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
		let cookieAccessToken = this.getCookie("sapphire");
		document.cookie = "sapphire="+cookieAccessToken+";domain=.malaysiaairlines.com;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }
    getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}

	

}

let scope:Element = document.querySelector('#enrich-nav-sidebar');
if (scope){
	try {
		//alert("in js....");
		let enrichLogout = new enrichMenuLogout();
			enrichLogout.logoutHandler();
	} catch(e) {console.error(e);}
}
